import { render } from "./DeclareAudit.vue?vue&type=template&id=28c7c4f6"
import script from "./DeclareAudit.vue?vue&type=script&lang=js"
export * from "./DeclareAudit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__